// Set the date we're counting down to
var countDownDate = new Date("Dec 25, 2023 14:00:00 GMT-0500").getTime();

// Update the count down every 1 second
var x = setInterval(function() {

  // Get today's date and time
  var now = new Date().getTime();

  // Find the distance between now and the count down date
  var distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  if (days < 1){
    // Display the result in the element with id="countdowny"
    if(document.getElementById("countdowny"))
  	document.getElementById("countdowny").innerHTML = hours + "h "
 	+ minutes + "m " + seconds + "s ";
  } else {
  // Display the result in the element with id="countdowny"
        if(document.getElementById("countdowny"))
  document.getElementById("countdowny").innerHTML = hours + "h "
  + minutes + "m " + seconds + "s ";
    
  }

  // If the count down is finished, write some text
  if (distance < 0) {
    clearInterval(x);
        if(document.getElementById("countdowny")){
    document.getElementById("countdowny").innerHTML = "0h 0m 0s";
    document.getElementById("timerContainer").style.display = "none";
    document.getElementById("shipping_xmas").style.display = "none";
        }
  }
}, 1000);